import apiClient from './api';
import { Brand } from '@/types/auth.types';

/** Raw catalog shape from BFF (id = account_group_code in BQ per API contract). */
type CatalogAccountGroupRow = {
  id: string;
  name: string;
  account_group_code?: string;
};

function normalizeCatalogBrand(raw: CatalogAccountGroupRow): Brand | null {
  const id = String(raw.id ?? '').trim();
  const name = String(raw.name ?? '').trim();
  const explicitCode = raw.account_group_code?.trim();

  if (!id) {
    return null;
  }

  return {
    id,
    name: name || id,
    account_group_code: explicitCode || id,
  };
}

export const brandService = {
  getBrands: async (tenantCode: string): Promise<Brand[]> => {
    const response = await apiClient.get<CatalogAccountGroupRow[]>(
      `/catalog/${tenantCode}/account-groups`
    );
    const list = response.data.map(normalizeCatalogBrand).filter((b): b is Brand => b !== null);

    return list;
  },
};
